import * as cnt from './constants';

const initialState = {
  companySettings: {},
  loading: false,
  loaded: false,
  errored: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${cnt.GET_SETTINGS}_STARTED`:
      return {
        ...state,
        loading: true,
        errored: false,
      };
    case `${cnt.GET_SETTINGS}_SUCCESS`:
      return {
        ...state,
        ...payload,
        errored: false,
        loading: false,
      };
    case `${cnt.GET_SETTINGS}_ERROR`:
      return {
        ...state,
        loading: false,
        errored: true,
      };
    case `${cnt.SAVE_SETTINGS}_STARTED`:
      return {
        ...state,
        loading: true,
        errored: false,
      };
    case `${cnt.SAVE_SETTINGS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        errored: false,
        ...payload,
      };
    case `${cnt.SAVE_SETTINGS}_ERROR`:
      return {
        ...state,
        loading: false,
        errored: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/settings/__store__/reducer.js